module.exports = __webpack_public_path__ + "media/images/steps/step_18-4abea5b93020258705cf9a61bbbff88a.svg";